import { useTranslation } from "react-i18next";

import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";
import { CurrentCompany } from "../../../../models/CurrentCompany";
import {
  ListViewHeaderCell,
  ListViewHeaderIconSpacer,
  ListViewHeaderRow,
  ListViewStickyHeader,
} from "../../../../share/searchResults";
import SearchResultsResponsive from "../../../../share/searchResults/SearchResultsResponsive";
import CompanySearchResultItem from "./CompanySearchResultItem";

const CompanySearchResults = () => {
  const {
    setCleanAllCompanyFilters,
    getDefaultCompanyResult,
    refreshFeedForCompaniesSearchResults,
  } = useActions();

  const { companies, count } = useTypedSelector(
    (state) => state.mapCompanyInfo
  );
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);

  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderHeader =
    isListViewActive && !isMobile && Boolean(companies && companies.length > 0);

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.listView.headers.companies",
  });

  const handleClean = () => {
    setCleanAllCompanyFilters();
    getDefaultCompanyResult();
  };

  return (
    <SearchResultsResponsive
      count={count}
      handleLoadFeed={refreshFeedForCompaniesSearchResults}
      onClearAllFilters={handleClean}
    >
      {shouldRenderHeader && (
        <ListViewStickyHeader>
          <ListViewHeaderRow>
            <ListViewHeaderIconSpacer aria-hidden="true" />
            <ListViewHeaderCell flex="2 1 320px">
              {t("company")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 200px">
              {t("status")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 200px">
              {t("registrationDate")}
            </ListViewHeaderCell>
          </ListViewHeaderRow>
        </ListViewStickyHeader>
      )}
      {companies?.map((mapObject: CurrentCompany) => {
        return (
          <CompanySearchResultItem
            key={mapObject.RECORD}
            mapObject={mapObject}
          />
        );
      })}
    </SearchResultsResponsive>
  );
};

export default CompanySearchResults;
